import { Component, OnDestroy, OnInit, inject } from "@angular/core";
import { Subscription } from "rxjs";
import { OrganizationService, ZuoraService } from '../../../services/rnapi2-service/apis/api';
import {
  RnCommonId,
  RnOrganizationPaymentOnFileVM,
  RnOrganizationsProfileVM,
  RnZuoraInvoiceGroup,
} from "../../../services/rnapi2-service/models/models";
import { SelectionService } from "../../../services/selection/selection.service";
import dayjs from "dayjs";
import { ToasterService, ToastType } from "@rn-platform/frontend-shared-data-access-toaster";

@Component({
    selector: "invoices",
    templateUrl: "./invoices.component.html",
    styleUrls: ["./invoices.component.scss"],
    standalone: false
})
export class InvoicesComponent implements OnInit, OnDestroy {
  private selectionService = inject(SelectionService);
  private organizationService = inject(OrganizationService);
  private toasterService = inject(ToasterService);
  private zuoraService = inject(ZuoraService);

  public selectedOrg: RnOrganizationsProfileVM = new RnOrganizationsProfileVM();
  public rnOrganizationPaymentOnFileVM: RnOrganizationPaymentOnFileVM;
  private subscriptions: Subscription[] = [];
  public tabs: InvoiceTabItem[] = [];
  public invoiceGroups: RnZuoraInvoiceGroup[] = [];
  public loading = false;

  ngOnInit(): void {
    if (this.selectionService.SelectedOrgProfile) {
      this.loading = true;
      const selectedOrgSub = this.selectionService.SelectedOrgProfile.subscribe({
        next: (result) => {
          this.selectedOrg = result;
          if (this.selectedOrg === null) return;

          if (
            this.organizationService.apiV2OrganizationsCurrentpaymentinfoPost
          ) {
            this.organizationService
              .apiV2OrganizationsCurrentpaymentinfoPost({
                Id: this.selectedOrg.ID.toString(),
              })
              .subscribe({
                next: (result) => {
                  if (result.Success) {
                    this.rnOrganizationPaymentOnFileVM = result.data;

                    if (
                      !this.rnOrganizationPaymentOnFileVM ||
                      !this.rnOrganizationPaymentOnFileVM.PaymentMethods ||
                      this.rnOrganizationPaymentOnFileVM.PaymentMethods
                        .length == 0
                    ) {
                      return;
                    }

                    const rnCommonId: RnCommonId = {
                      Id: this.selectedOrg.ZuoraID,
                      AffectedOrganizationId: this.selectedOrg.ID,
                    };

                    if (
                      this.zuoraService.apiV2ZuoraGetorganizationinvoicesPost
                    ) {
                      this.zuoraService
                        .apiV2ZuoraGetorganizationinvoicesPost(rnCommonId)
                        .subscribe({
                          next: (result) => {
                            this.invoiceGroups = result.data;
                            result.data.forEach((value) => {
                              const tabItem: InvoiceTabItem = {
                                heading: value.Heading,
                                invoices: value.Invoices,
                                selected: false,
                              };
                              this.tabs.push(tabItem);
                            });

                            if (this.tabs.length > 0) {
                              this.tabs[0].selected = true;
                            }
                          },
                          error: (error) => {
                            console.error(error);
                            const message = 'There was a problem getting the invoices for this organization';
                            const id = 'apphub-invoices-get-invoices-error-toast';
                            this.toasterService.addToast(ToastType.Error_, message, message, id, id);
                          },

                          complete: () => {
                            this.loading = false;
                          },
                        });
                    }
                  } else {
                    console.error(result.Messages);
                  }
                },
                error: (error) => {
                  console.error(error);
                },
              });
          }
        },
        error: (err) => {
          console.error(err);
        },
      });
      this.subscriptions.push(selectedOrgSub);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  public getInvoicePdf(invoiceId, invoiceNumber: string, invoiceDate) {
    const rnCommonId: RnCommonId = {
      Id: invoiceId,
      AffectedOrganizationId: this.selectedOrg.ID,
    };
    if (this.zuoraService) {
      this.zuoraService
        .apiV2ZuoraGetinvoicepdfPost(rnCommonId)
        .subscribe({
          next: (result) => {
            if (result) {
              const filename =
                this.selectedOrg.Name.replace(/[^A-Z0-9]/gi, "") +
                "_" +
                invoiceNumber +
                "_" +
                dayjs(invoiceDate).format("YYYY-MMM-DD") +
                ".pdf";
              const contentType = "application/pdf";

              const linkElement = document.createElement("a");
              try {
                const blob = new Blob([result], { type: contentType });
                const url = window.URL.createObjectURL(blob);

                linkElement.setAttribute("href", url);
                linkElement.setAttribute("download", filename);

                const clickEvent = new MouseEvent("click", {
                  view: window,
                  bubbles: true,
                  cancelable: false,
                });
                linkElement.dispatchEvent(clickEvent);
              } catch (ex) {
                console.log(ex);
              }
            } else {
              console.log('There was an error in loading the PDF for the invoice');
              const message =
                'There was an error in loading the PDF for the invoice.  Please contact support for further assistance.';
              const id = 'apphub-invoices-get-invoices-error-toast';
              this.toasterService.addToast(ToastType.Error_, message, message, id, id);
            }
          },
          error: (error) => {
            console.error(error);
            const message =
                'There was an error in loading the PDF for the invoice.  Please contact support for further assistance.';
              const id = 'apphub-invoices-get-invoices-error-toast';
              this.toasterService.addToast(ToastType.Error_, message, message, id, id);
          },
        });
    }
  }
}
export class InvoiceTabItem {
  heading: string;
  invoices: any;
  selected = false;
}
